import { Input } from "antd";
import { useReactFlow } from "reactflow";
import { useEffect, useRef } from "react";
import { TextAreaRef } from "antd/lib/input/TextArea";
import { useNodesTitle } from "@custom-hooks/HomeUsePluginRoot/useNodesTitle";
import { useAISaasPreviewItem } from "../../../hooks/useAISaasPreviewItem";
import { useRenderData } from "../../../hooks/useRenderData";
import style from "../index.module.scss";
import func from "@uikit/func";

type PreviewTitleProps = {
  id: string;
  title: string;
  isShare: boolean;
  showInputTitleId: string;
  saasUIInputData: any;
  inputTitleId: string;
  onSaasInputTitleChange: (e: any, id: string) => void;
  onInputTitleEnter: (e: any, id: string) => void;
  onInputTitleBlur: () => void;
  onClickInputTitleClose: (e: any, id: string) => void;
  onClickEdit: (e: any, data: any) => void;
};

const hideAndDisplay = (key: boolean) => {
  return key ? style["display-box"] : style["hide-box"];
};

export function PreviewTitle({ title, saasUIInputData }: PreviewTitleProps) {
  const inputTitleRef = useRef(null);
  const renderData = useRenderData({ type: "inputLabel", id: saasUIInputData.id });

  return (
    <div style={renderData?.style} ref={inputTitleRef}>
      <div style={renderData?.style} className={style["input-title-piece"]}>
        {title}
      </div>
    </div>
  );
}
